import { jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
export function Button({ variant = "secondary", size = "md", icon, children, className, type = "button", ...rest }) {
    return (_jsxs("button", { type: type, className: clsx("btn", `btn-${variant}`, size === "lg" && "btn-lg", size === "xl" && "btn-xl", className), ...rest, children: [icon, children] }));
}
//# sourceMappingURL=Button.js.map